"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AlertDialog_1 = __importDefault(require("@/components/AlertDialog"));
const Loader_1 = __importDefault(require("@/components/Loader"));
const style_1 = require("./style");
function ComponentsDialogAlertView({ isOpen, onClose, onDismiss, onProceed, userToBeDeleted, isDeleting, deletionErrorMessage, }) {
    const text = react_1.default.useMemo(() => {
        if (isDeleting) {
            return (react_1.default.createElement(style_1.LoaderWrapper, null,
                "Wait a moment while we are processing your request...",
                react_1.default.createElement(Loader_1.default, { height: 60, width: 60 })));
        }
        if (deletionErrorMessage) {
            return react_1.default.createElement(react_1.default.Fragment, null, deletionErrorMessage);
        }
        return react_1.default.createElement(react_1.default.Fragment, null);
    }, [isDeleting, userToBeDeleted]);
    const title = react_1.default.useMemo(() => {
        if (deletionErrorMessage) {
            return "Error";
        }
        return `Delete "${userToBeDeleted}"?`;
    }, [userToBeDeleted, deletionErrorMessage]);
    return isOpen ? (react_1.default.createElement(AlertDialog_1.default, { dialogTitle: title, text: text, dismissActionLabel: "Cancel", proceedWithActionLabel: "Delete anyway", isOpen: isOpen, onClose: onClose, onDismiss: onDismiss, onProceed: onProceed, isOnProceedButtonDisabled: isDeleting })) : null;
}
exports.default = ComponentsDialogAlertView;
